import { render, staticRenderFns } from "./RewardRecord.vue?vue&type=template&id=9c59ffe6"
import script from "./RewardRecord.vue?vue&type=script&lang=js"
export * from "./RewardRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports